






import {Component, Prop, Vue} from 'vue-property-decorator'
import {WidgetDefinition, WSize} from '@/components/widgets/WidgetFather'

@Component({})
export default class NetInternalArea extends Vue {
  @Prop({default: 2}) public config?: WidgetDefinition
  private hh = WSize.headerHeight

  get width() {
    let w = this.config && this.config.w ? this.config.w : 2
    return String((WSize.single.w + 10) * w) + 'px'
  }

  get height() {
    let h = this.config && this.config.h ? this.config.h : 2
    return String((WSize.single.h + WSize.headerHeight) * h) + 'px'
  }
}
